"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definition = void 0;
const lodash_functions_1 = require("../../../../util/lodash-functions");
const default_session_1 = require("../../../../session/default-session");
const curves_provider_1 = require("../curves-provider");
function Definition(params, outputs) {
    let parameters;
    if ((0, lodash_functions_1.isPlainObject)(params)) {
        parameters = params;
    }
    else {
        parameters = {
            universe: params,
            outputs,
        };
    }
    return {
        getData(session = (0, default_session_1.getDefault)()) {
            const curvesProvider = new curves_provider_1.CurvesProvider(session);
            return curvesProvider.getForwardCurves(parameters);
        },
    };
}
exports.Definition = Definition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2lwYS9jdXJ2ZXMvZm9yd2FyZC1jdXJ2ZXMvZGVmaW5pdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQSx3RUFBa0U7QUFDbEUseUVBQWlFO0FBQ2pFLHdEQUFvRDtBQU9wRCxTQUFnQixVQUFVLENBQ3RCLE1BQXVHLEVBQ3ZHLE9BQWtCO0lBRWxCLElBQUksVUFBMkMsQ0FBQztJQUNoRCxJQUFJLElBQUEsZ0NBQWEsRUFBQyxNQUFNLENBQUMsRUFBRSxDQUFDO1FBQ3hCLFVBQVUsR0FBRyxNQUF5QyxDQUFDO0lBQzNELENBQUM7U0FBTSxDQUFDO1FBQ0osVUFBVSxHQUFHO1lBQ1QsUUFBUSxFQUFFLE1BQTZCO1lBQ3ZDLE9BQU87U0FDVixDQUFDO0lBQ04sQ0FBQztJQUVELE9BQU87UUFDSCxPQUFPLENBQUMsVUFBbUIsSUFBQSw0QkFBVSxHQUFFO1lBQ25DLE1BQU0sY0FBYyxHQUFHLElBQUksZ0NBQWMsQ0FBQyxPQUFPLENBQUMsQ0FBQztZQUNuRCxPQUFPLGNBQWMsQ0FBQyxnQkFBZ0IsQ0FBQyxVQUFVLENBQUMsQ0FBQztRQUN2RCxDQUFDO0tBQ0osQ0FBQztBQUNOLENBQUM7QUFwQkQsZ0NBb0JDIn0=